import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useEditBookMutation, useGetBookQuery } from "../features/api/apiSlice";

function EditBook() {
  const { id } = useParams();
  const { data, isLoading, error } = useGetBookQuery(id);

  const [
    editBook,
    { isLoading: submissionLoading, isSuccess: submissionSuccess, isError },
  ] = useEditBookMutation();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [author, setAuthor] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [price, setPrice] = useState("");
  const [rating, setRating] = useState("");
  const [featured, setFeatured] = useState("");

  useEffect(() => {
    setName(data?.name);
    setAuthor(data?.author);
    setThumbnail(data?.thumbnail);
    setPrice(data?.price);
    setRating(data?.rating);
    setFeatured(data?.featured);
  }, [data]);

  function handleSubmit(event) {
    event.preventDefault();
    const payload = { name, author, thumbnail, price, rating, featured };
    editBook({ id, data: payload });
  }

  useEffect(() => {
    if (submissionSuccess) {
      navigate("/");
    }
  }, [navigate, submissionSuccess]);

  let content = null;
  if (isLoading) content = "Loading....";
  if (!isLoading && error) content = "Something went wrong!";
  if (!isLoading && !error && Object.keys(data)?.length > 0)
    content = (
      <form className="book-form" onSubmit={handleSubmit}>
        <div className="space-y-2">
          <label for="lws-bookName">Book Name</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-bookName"
            name="name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </div>

        <div className="space-y-2">
          <label for="lws-author">Author</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-author"
            name="author"
            value={author}
            onChange={(event) => setAuthor(event.target.value)}
          />
        </div>

        <div className="space-y-2">
          <label for="lws-thumbnail">Image Url</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-thumbnail"
            name="thumbnail"
            value={thumbnail}
            onChange={(event) => setThumbnail(event.target.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-8 pb-4">
          <div className="space-y-2">
            <label for="lws-price">Price</label>
            <input
              required
              className="text-input"
              type="number"
              id="lws-price"
              name="price"
              value={price}
              onChange={(event) => setPrice(event.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label for="lws-rating">Rating</label>
            <input
              required
              className="text-input"
              type="number"
              id="lws-rating"
              name="rating"
              min="1"
              max="5"
              value={rating}
              onChange={(event) => setRating(event.target.value)}
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            id="lws-featured"
            type="checkbox"
            name="featured"
            className="w-4 h-4"
            checked={featured}
            onChange={() => setFeatured(!featured)}
          />
          <label for="lws-featured" className="ml-2 text-sm">
            {" "}
            This is a featured book{" "}
          </label>
        </div>

        {isError && <span> Something Went Wrong...</span>}
        <button
          type="submit"
          className="submit"
          id="lws-submit"
          disabled={submissionLoading}
        >
          Edit Book
        </button>
      </form>
    );

  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
          {content}
        </div>
      </div>
    </main>
  );
}

export default EditBook;
